export const CURRENT_SEGMENT_EVENT_VERSION = '4.1';

export const trackSegmentEventV2 = ({ type, metaData }) => {
  window.segmentV2?.track(type, {
    ...metaData,
    version: CURRENT_SEGMENT_EVENT_VERSION
  });
};
